import { render, staticRenderFns } from "./junction-box-terminal-block.component.vue?vue&type=template&id=8e64c944&scoped=true"
import script from "./junction-box-terminal-block.component.ts?vue&type=script&lang=ts&external"
export * from "./junction-box-terminal-block.component.ts?vue&type=script&lang=ts&external"
import style0 from "./junction-box-terminal-block.component.vue?vue&type=style&index=0&id=8e64c944&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e64c944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e64c944')) {
      api.createRecord('8e64c944', component.options)
    } else {
      api.reload('8e64c944', component.options)
    }
    module.hot.accept("./junction-box-terminal-block.component.vue?vue&type=template&id=8e64c944&scoped=true", function () {
      api.rerender('8e64c944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/junction-box-terminal-block/junction-box-terminal-block.component.vue"
export default component.exports